import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CashReconciliationDetailsFormProps } from "models/propTypes/cashReconciliationPropTypes";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region  components
import { GenericForm } from "components/common";
//#endregion

const CashReconciliationDetailsForm: ForwardRefRenderFunction<FormHandles, CashReconciliationDetailsFormProps> = (
  props,
  ref
) => {
  const { cashRegister } = props;

  const getFields = (items?: WintSuperkollAPIModel.CashReconciliationItemInstance[]) => {
    const fields: any = {};

    items?.forEach((res, index) => {
      fields[`${res.category}_${index}`] = {
        label: `${res.description}`,
        type: FormEnums.FormFieldType.TEXT,
      };
    });
    return fields;
  };

  const fields = [
    {
      label: TranslationKeys.Common.Sale,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      icon: IconDefinitionConstants.WMoney,
      innerFields: {
        ...getFields(
          cashRegister?.items?.filter(
            (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.Sales
          )
        ),
        saleTotal: {
          label: TranslationKeys.Common.InTotal,
          type: FormEnums.FormFieldType.TEXT,
        },
      },
    },
    {
      label: TranslationKeys.Common.PaymentMethod,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      icon: IconDefinitionConstants.WCreditCard,
      innerFields: {
        ...getFields(
          cashRegister?.items?.filter(
            (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.PaymentMethod
          )
        ),
        paymentMethodsTotal: {
          label: TranslationKeys.Common.InTotal,
          type: FormEnums.FormFieldType.TEXT,
        },
      },
    },
    {
      label: TranslationKeys.Common.Other,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      icon: IconDefinitionConstants.WTransactions,
      innerFields: {
        ...getFields(
          cashRegister?.items?.filter(
            (item) => item.category === WintSuperkollAPIModel.CashReconciliationItemCategory.Other
          )
        ),
        otherTotal: {
          label: TranslationKeys.Common.InTotal,
          type: FormEnums.FormFieldType.TEXT,
        },
      },
    },
  ];
  return <GenericForm formRef={ref} {...props} fields={fields} isReadOnly inline hideSuccess />;
};

export default forwardRef(CashReconciliationDetailsForm);
